import React from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <Link to="/" className="logo">تعلم الإنجليزية للأطفال</Link>
          <ul className="nav-links">
            <li><Link to="/">الرئيسية</Link></li>
            <li><Link to="/games">الألعاب التعليمية</Link></li>
            <li><Link to="/tips">نصائح للأهالي</Link></li>
            <li><Link to="/schedule">مواعيد الكورسات</Link></li>
            <li><Link to="/about">عن المعلمة</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
